export const HOME_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const SIGN_UP_ROUTE = '/signup';
